import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#0057B8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.335 4.667-6.667 6.666m6.667-6.666h-6m6 0v6"
    }, null, -1)
  ]))]))
}
export default { render: render }